import React, {Component} from 'react';
import {calcDone, getSectionAnswer, isSectionQuestionHidden} from "../../../common/section-questions/sections";
import {ProgressBar} from "react-bootstrap";
import Transition from "./Transition";
import {useTransitionEndEventName} from "../../hooks/useTransitionEndEventName";
import {FaStepBackward, FaStepForward} from "react-icons/fa";

class Transitioner extends Component {
    constructor(props) {
        super(props);
        let visible =  this.visibleQuestions()
        let firstUnanswered = visible.findIndex(item=>{
            return [undefined,null].includes(getSectionAnswer(this.props.section,item))
        })
        let start = firstUnanswered === -1 ? visible.length -1 : firstUnanswered
        this.state = {
            index: start,
            prevIndex: start-1,
            forwards: true,
        }
    }
    transitionName = useTransitionEndEventName()

    retreat = () => {
        this.setState(prevState => {
            prevState.prevIndex = prevState.index
            prevState.index = prevState.index - 1
            prevState.forwards = false
            return prevState
        }, () => {
            if (this.props?.onReturn && this.state.index < 0) {
                this.props.onReturn()
            }
        })
    }
    advance = () => {
        this.setState(prevState => {
            prevState.prevIndex = prevState.index
            prevState.forwards = true
            prevState.index = prevState.index + 1
            return prevState
        }, () => {
            const visibleQuestions = this.visibleQuestions();
            if (this.state.index >= visibleQuestions.length ) {
                setTimeout(()=>{
                    this.props.onFinish()
                },200)
            }
        })
    }
    visibleQuestions = () => {
        return this.props.section.questions.filter(question => {
            return !isSectionQuestionHidden(this.props.section, question)
        })
    }

    render() {
        if (this.state.index < 0){
            return <></>
        }
        const visible = this.visibleQuestions()
        let pos = Math.floor(((this.state.index) / visible.length) * 100)
        let key = visible.length <= this.state.index ? 'end' : visible[this.state.index].label + this.props.section.applicant + this.state.forwards
        return (
            <>
                <ProgressBar className="" now={pos}/>
                <Transition
                    key={key}
                    backPossible={true}
                    forwardPossible={true}
                    advance={this.advance}
                    retreat={this.retreat}
                    forwards={this.state.forwards}
                    transitionName={this.transitionName}
                    question={visible[this.state.index] || false}
                    section={this.props.section}
                    progress={pos}
                />
            </>

        )

    }
}

export default Transitioner;

